<template>
    <div>
        <div class="rounded-0 trash-content-display">
            <!-- Loading icon -->
            <Loading v-if="isLoading"/>
            <div class="card h-100 rounded-0 border-0">
                <div class="card-body p-0">
                    <!-- Step 0 -->
                    <ZipCode
                        v-if="currentStep === STEP_1_OF_GENERAL && followStep === FOLLOW_GENERAL"
                        :formValue="formValue.general"
                        :animation="animation"
                        @onChangeFormValue="onChangeFormValue"
                        @handleChangeStep="handleChangeStep"
                        :headerClass="headerClass"
                        :classPaddingParentBanner="classPaddingParentBanner"
                        :classPaddingParentTop="classPaddingParentTop"
                        :classFormGroupBanner="classFormGroupBanner"
                        :classFormGroupTop="classFormGroupTop"
                        :classMarginButton="classMarginButton"
                    />
                    <GarbageType
                        v-if="currentStep === STEP_2_OF_GENERAL && followStep === FOLLOW_GENERAL"
                        :animation="animation"
                        @handleChangeStep="handleChangeStep"
                        @setTrashType="setTrashType"
                    />

                    <!-- 粗大 -->
                    <AmountGarbage
                        v-if="currentStep === STEP_1_OF_OVERSIZED && followStep === FOLLOW_OVERSIZED"
                        :animation="animation"
                        @handleChangeStep="handleChangeStep"
                        @setAmountOfGarbage="setAmountOfGarbage"
                    />
                    <TypeOfGarbage
                        v-if="currentStep === STEP_2_OF_OVERSIZED && followStep === FOLLOW_OVERSIZED"
                        :animation="animation"
                        :formValue="formValue.trashOversized"
                        :allData="formValue"
                        @handleChangeStep="handleChangeStep"
                        @onChangeFormValue="onChangeFormValue"
                    />
                    <LocateCollection
                        v-if="currentStep === STEP_3_OF_OVERSIZED && followStep === FOLLOW_OVERSIZED"
                        :followStep="followStep"
                        :animation="animation"
                        :allData="formValue"
                        @handleChangeStep="handleChangeStep"
                    />
                    <NumberOfStorey
                        v-if="currentStep === STEP_4_OF_OVERSIZED && followStep === FOLLOW_OVERSIZED"
                        :followStep="followStep"
                        :animation="animation"
                        :formValue="formValue.trashOversized"
                        :allData="formValue"
                        @handleChangeStep="handleChangeStep"
                        @onChangeFormValue="onChangeFormValue"
                    />

                    <!-- 家電 -->
                    <TypeOfAppliance
                        v-if="currentStep === STEP_1_OF_APPLIANCE && followStep === FOLLOW_APPLIANCE"
                        :animation="animation"
                        :allData="formValue.trashAppliance"
                        :formValue="formValue"
                        @handleChangeStep="handleChangeStep"
                        @onChangeFormValue="onChangeFormValue"
                    />
                    <LocateCollection
                        v-if="currentStep === STEP_2_OF_APPLIANCE && followStep === FOLLOW_APPLIANCE"
                        :followStep="followStep"
                        :animation="animation"
                        :allData="formValue"
                        @handleChangeStep="handleChangeStep"
                    />
                    <NumberOfStorey
                        v-if="currentStep === STEP_3_OF_APPLIANCE && followStep === FOLLOW_APPLIANCE"
                        :followStep="followStep"
                        :animation="animation"
                        :formValue="formValue.trashAppliance"
                        :allData="formValue"
                        @handleChangeStep="handleChangeStep"
                        @onChangeFormValue="onChangeFormValue"
                    />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import ZipCode from './ZipCode.vue';
    import GarbageType from './GarbageType.vue';
    import AmountGarbage from './OversizedGarbage/AmountGarbage.vue';
    import TypeOfGarbage from './OversizedGarbage/TypeOfGarbage.vue';
    import NumberOfStorey from './NumberOfStorey.vue';
    import TypeOfAppliance from './ApplianceGarbage/TypeOfAppliance.vue';
    import Loading from './Loading/Loading.vue';
    import LocateCollection from './LocateCollection.vue';

    export default {
        name: 'RegisterEstimate',
        props: {
            headerClass: {
                default: 'offset-sm-1'
            },
            classPaddingParentBanner: {
                default: ''
            },
            classPaddingParentTop: {
                default: ''
            },
            classFormGroupBanner: {
                default: ''
            },
            classFormGroupTop: {
                default: ''
            },
            classMarginButton: {
                default: 'mt-3'
            },
        },
        data() {
            return {
                FOLLOW_GENERAL: 0,
                FOLLOW_OVERSIZED: 1,
                FOLLOW_APPLIANCE: 2,

                // STEP_1_OF_GENERAL: -1,
                // STEP_2_OF_GENERAL: 0,
                STEP_1_OF_GENERAL: 1,
                STEP_2_OF_GENERAL: 2,

                STEP_1_OF_OVERSIZED: 1,
                STEP_2_OF_OVERSIZED: 2,
                STEP_3_OF_OVERSIZED: 3,
                STEP_4_OF_OVERSIZED: 4,

                STEP_1_OF_APPLIANCE: 1,
                STEP_2_OF_APPLIANCE: 2,
                STEP_3_OF_APPLIANCE: 3,

                isLoading: false,
                currentStep: 1,
                followStep: 0, 
                animation: 'animation-in',

                // All data
                formValue: {
                    general: {
                        zipCode: '',
                        address: '',
                        trashType: '',
                    },
                    trashOversized: {
                        amountOfGarbage: '',
                        typeOfOverSizeGarbage1: '',
                        typeOfOverSizeGarbage2: '',
                        typeOfOverSizeGarbage3: '',
                        typeOfSizeGarbageOther: '',
                        numberOfStorey: '',
                    },
                    trashAppliance: {
                        totalPrice: 0,
                        numberOfStorey: '',
                        orders: [],
                    },
                },
            }
        },
        methods: {
            handleChangeStep(currentStep = 0, flowStep = 0) {
                this.animation = 'animation-out'
                setTimeout(() => {
                    this.animation = 'animation-in'
                    this.currentStep = currentStep;
                    this.followStep = flowStep;
                }, 100);
            },
            onChangeFormValue(payload) {
                this.formValue = {
                    ...this.formValue,
                    [payload.label]: payload.data
                }
            },
            setAmountOfGarbage(payload) {
                this.formValue = {
                    ...this.formValue,
                    trashOversized: {
                        ...this.formValue.trashOversized,
                        amountOfGarbage: payload.data.amountOfGarbage
                    }
                }
            },
            setTrashType(payload) {
                this.formValue = {
                    ...this.formValue,
                    general: {
                        ...this.formValue.general,
                        trashType: payload.data.trashType   
                    }
                }
            },
        },
        components: {
            ZipCode,
            GarbageType,
            AmountGarbage,
            TypeOfGarbage,
            NumberOfStorey,
            TypeOfAppliance,
            Loading,
            LocateCollection
        }
    }
</script>

<style>
hr.border-primary {
        border-color: #0FA36A !important;
    }
    #item2 {
        top: 0;
        left: 0;
    }
    .card .card-body .card-body{
        width: 90%;
        margin: 0 auto;
        padding: 0 0 90px 0;
    }
    .qty-bag {
        font-size: 1rem !important;
    }
    @media only screen and (max-width: 1200px) {
        .card .card-body .card-body {
            width: 95%;
        }
        .form-wrap-step {
            width: 95% !important;
        }
    }
    @media only screen and (max-width: 480px) {
        .px0 {
            padding: 0 !important;
        }
        .btn-zip-sm-size {
            font-size: 10px
        }
        .lb-below-adv {
            max-width: 35% !important;
            flex: unset !important;
            font-size: 12px !important;
        }

        .in-below-adv {
            max-width: 65% !important;
            padding-left: 6px;
            flex: unset !important;
        }

        .in-below-adv-indiv {
            max-width: 65% !important;
            flex: unset !important;
            padding: 0px 0px 0px 10px;
        }
        .in-below-adv input,
        .in-below-adv-indiv input{
            font-size: 12px !important;
        }

        .below-adv {
            max-width: 100% !important;
            flex: unset !important;
            padding-right: 0;
        }    
        .below-adv-zip {
            max-width: 100% !important;
            flex: unset !important;
            padding: 0px 3px;
        }

        .below-adv-btn {
            margin: 0px;
            font-size: 10px;
        }

        .below-adv-btn button:first-child {
            margin-right: 0px;
        }

        .below-adv-btn button#btnOversizeGarbage {
            margin-top: 10px;
        }

        .btn-zip {
            display: none !important;
        }

        .btn-zip-top-sm {
            margin-left: 0;
            flex: 0 0 100% !important;
            max-width: 100% !important;
        }
        .qty-bag {
            font-size: .8rem !important;
        }
        .form-group.row {
            margin-bottom: 10px !important;
        }
        .form-wrap-step .form-header h5 {
            padding-top: 15px !important;
        }
        /* .card .card-body .card-body {
            padding-bottom: 68px !important;
        } */
        .btn-lg {
            font-size: unset !important;
        }
        .flex {
            display: flex !important;
        }
        .sm-header {
            font-size: 14px !important;
        }
        .label1 {
            font-size: 10px !important;
        }
        .mb-sm-label {
            margin-bottom: 0.5rem !important;
        }
        .card .card-body .card-body{
            padding: 0 !important;
        }
        .row .col-sm-12 {
            padding-left: 12px;
            padding-right: 12px;
        }
        .mt-100 {
            margin: 50px 0 0 0 !important;
        }
        .mt-60 {
            margin: 60px 0 0 0 !important;
        }
    }
    .btnZipCode {
        font-size: 16px;
    }
    .form-wrap-step {
        width: 100%;
    }
    .form-wrap-step .form-header h5 { 
        padding-top: 90px;
        padding-bottom: 20px;
        color: #333;
    }
    .form-wrap-step h5 {
        color: #333;
    }
    /* .form-wrap-step button:not(:last-child) {
        margin-right: 10px;
    }  */
    .form-wrap-step button {
        background-color: #f5886e !important;
        border-color: #f5886e !important;
        font-weight: 500;
        transition: 0.2s;
        box-shadow: 0px 2px 4px -1px rgb(0 0 0 / 20%), 0px 4px 5px 0px rgb(0 0 0 / 14%), 0px 1px 10px 0px rgb(0 0 0 / 12%);
    }
    .form-wrap-step .zipcode {
        margin-top: 60px;
    }
    .form-wrap-step button:hover {
        background-color: #2196F3;
        border-color: #2196F3;
    }
    .animation-out {
        opacity: 0;
        animation: out 0.4s ;
    }
    .animation-in {
        animation: in 0.4s ;
    }
    .form-wrap-step .btnZipCode {
        color: #fff !important;
        background-color: #858796 !important;
        border-color: #858796 !important;
        padding: 6px;
    }
    .px-33 {
        padding: 33px 0;
    }
    .py-175 {
        padding: 0 175px;
    }
    .mt-100  {
        margin: 100px 0 0 0;
    }

    .mt-60 {
        margin: 100px 0 0 0;
    }

    @keyframes in {
        from {
            transform: scale(0);
            opacity: 0;
        }
        to {
            transform: scale(1);
            opacity: 1;
        }
    }
    @keyframes out {
        from {
            transform: scale(1);
            opacity: 1;
        }
        to {
            transform: scale(0);
            opacity: 0;
        }
    }
</style>